module.exports = __webpack_public_path__ + "img/70.fa1a944a.jpg";